<template>
  <div class="box elevation-0" v-bind:class="colorclass">
    <div class="isi">{{formatAngka(value)}}</div>
    <div class="judul">{{title}}</div>
    <div class="iconbox"><v-icon color="white" size="70">{{icon}}</v-icon></div>
  </div>
</template>

<script>
import Utils from '@/plugins/utils'

export default {
  name: 'DashBoardBox',
  props: ['title', 'value', 'colorclass', 'icon'],
  methods: {
    formatAngka (val) {
      return Utils.formatAngka(val)
    }
  }
}
</script>

<style scoped>
.disco {
  background: linear-gradient(160deg,#3F5EFB 0%, #FC466B  100%);
}
.vivalocean {
  background: linear-gradient(160deg,  #000851  0%,#1CB5E0 100%);
}
.parfour  {
  background: linear-gradient(160deg, #008552 0%,#9ebd13 100%);
}
.aqua {
  background: linear-gradient(160deg, #3a47d5 0%, #00d2ff 100%);
}
.minosa {
  background: linear-gradient(160deg, #d53369 0%, #daae51 100%);
}
.box {
  position: relative;
  border: #cccccc 1px solid;
  border-radius: 16px;
  padding: 8px;
  padding-top: 20px;
  padding-left: 16px;
  padding-bottom: 20px;
}
.iconbox {
  position: absolute;
  float: right;
  top: 16px;
  justify-content: center;
  right: 16px;
}
.judul {
  font-size: 20px;
  color: white;
}
.isi {
  color: white;
  font-weight: bold;
  font-size: 25px;
}
</style>
